<template>
  <Wrapper>
    <Loading v-if="isLoading"></Loading>
    <BadRequest :lang="lang" v-if="isBadRequest"></BadRequest>
    <InternalServerError
      v-if="isCreateServerError"
      :lang="lang"
    ></InternalServerError>
    <main
      v-if="!isLoading && !isBadRequest && !isCreateServerError"
      class="main"
    >
      <ol
        class="breadcrumb-trail__list"
        v-if="!$route.path.includes('company')"
      >
        <li class="breadcrumb-trail__list--item">
          <router-link
            :to="{ path: `/${langPath}` }"
            class="breadcrumb-trail__list--item__link"
          >
            TOP
          </router-link>
        </li>
        <li class="breadcrumb-trail__list--item">
          <router-link
            :to="{ path: `/${langPath}result` }"
            class="breadcrumb-trail__list--item__link"
          >
            Results
          </router-link>
        </li>
        <li class="breadcrumb-trail__list--item">
          <router-link
            :to="{
              path: `/${langPath}ranking`,
              query: {
                event: this.$route.query.event,
                page: this.$route.query.page,
              },
            }"
            class="breadcrumb-trail__list--item__link"
          >
            {{ dataEventRanking.name }}
          </router-link>
        </li>
        <li class="breadcrumb-trail__list--item">
          <router-link
            :to="{
              path: `/${langPath}ranking/runner`,
              query: {
                event: this.$route.query.event,
                page: this.$route.query.page,
              },
            }"
            class="breadcrumb-trail__list--item__link"
          >
            {{ Ranking.pankuzuRunner[lang] }}
          </router-link>
        </li>
      </ol>
      <!-- 戻るボタン -->
      <router-link
        :to="{
          path: `/${langPath}${
            $route.path.includes('company') ? 'company/' : ''
          }ranking`,
          query: { event: this.$route.query.event, page: 1 },
        }"
        class="button flex-all-center"
        >{{ Ranking.return[lang] }}
      </router-link>
      <h1 class="page-title">
        <span class="strong">“{{ dataRunnerName }}” </span>
        {{ Ranking.searchResult[lang] }}
      </h1>
      <section class="section">
        <Status
          :is-loading-ranking="isLoadingRanking"
          :is-not-found="isNotFound"
          :is-server-error="isServerError"
          :is-initial-ranking-data="true"
          :event-status="eventStatus"
          :count-total-runner="countTotalRunner"
          :event-date-at="eventDateAt"
          @initial-ranking="initialRanking"
        ></Status>
        <!-- ランキング -->
        <RankingList
          v-if="!isLoadingRanking && !isNotFound && !isServerError"
          :lang="lang"
          :lang-path="langPath"
          :ranking="Ranking"
          :data-event-ranking="dataEventRanking"
          :data-event-summary="dataEventSummary"
          :data-ranking="dataRanking"
          :event-status="eventStatus"
          :is-foreign-country="isForeignCountry"
          :nass-event-id="nassEventId"
        ></RankingList>
        <v-pagination
          v-if="!isLoadingRanking && !isNotFound && !isServerError"
          v-model="$page.current"
          v-bind:length="$page.total"
          v-bind:total-visible="$page.visible"
          color="#0093e6"
          class="rank-pagination"
        ></v-pagination>
      </section>
      <!-- ユーザー検索 -->
      <UserSearch
        class="search-section"
        :lang="lang"
        :langPath="langPath"
      ></UserSearch>
    </main>
  </Wrapper>
</template>

<script>
import Wrapper from "../../../../components/sp/Wrapper";
import Loading from "../../../../components/sp/Loading";
import BadRequest from "../../../../components/common/status/BadRequest";
import InternalServerError from "../../../../components/common/status/InternalServerError";
import UserSearch from "../../../../components/sp/ranking/UserSearch";
import RankingList from "../../../../components/sp/ranking/RankingList";
import Ranking from "../../../../assets/constants/ranking/ranking";
import { RepositoryFactory } from "../../../../api/RepositoryFactory";
import Status from "../../../../components/sp/ranking/Status";
import cognito from "../../../../plugins/cognito";
const RankingRepository = RepositoryFactory.get("ranking");

export default {
  data() {
    return {
      isLoading: true,
      isLoadingRanking: true,
      isBadRequest: false,
      isCreateServerError: false,
      isForeignCountry: false,
      isNotFound: false,
      isServerError: false,
      dataEventRanking: null,
      dataEventSummary: {},
      dataRanking: null,
      dataRunnerName: "",
      nassEventId: "",
      eventStatus: "",
      eventDateAt: "",
      countTotalRunner: 0,
      offset: 0,
    };
  },
  async created() {
    // ユーザー名取得
    this.dataRunnerName = sessionStorage.getItem("runnerName");
    const EventRepository = RepositoryFactory.get("event");
    const isCompany = this.$route.path.includes("company");
    const params = {
      event: sessionStorage.getItem("nassEventId"),
      lang: this.lang,
      is_company_event: isCompany || "",
      company_user_name: cognito.getUserName() || "",
    };
    try {
      const response = await EventRepository.getEventRanking(params);
      this.dataEventRanking = response.data;
      this.isForeignCountry = response.data.text.new_event_api_flag;
      const rankingItem = response.data.ranking_item;
      this.dataEventSummary.ranking_items = rankingItem.includes(",")
        ? rankingItem.split(",")
        : ["性別", "年代", "居住地"];
      this.nassEventId = sessionStorage.getItem("nassEventId");
    } catch (e) {
      if (e.response.status === 400) {
        this.isBadRequest = true;
        return;
      }
      this.isCreateServerError = true;
    } finally {
      this.isLoading = false;
    }

    // ランキング取得
    await this.initialRanking();
  },
  methods: {
    /**
     * 初回検索
     */
    initialRanking: async function () {
      // 条件初期化
      this.isLoadingRanking = true;
      this.isNotFound = false;
      this.isServerError = false;
      this.dataRanking = "";
      await this.fetchRanking();
    },

    /**
     * 通信部分共通
     */
    fetchRanking: async function () {
      const param = {
        nass_event: this.nassEventId,
        offset: (this.$route.query.page - 1) * 100,
        limit: 100,
        size: 100,
        lang: this.lang,
        keyword: this.dataRunnerName
          ? this.dataRunnerName
          : (this.dataRunnerName = sessionStorage.getItem("runnerName")),
      };

      try {
        const response = await RankingRepository.getRanking(param);
        this.dataRanking = response.data;

        // 総件数（paging用と表示用）
        this.$page.rows = response.data.metadata.total_count;
        this.countTotalRunner = response.data.metadata.total_count;

        // イベントステータス（'0'か'100'）
        this.eventStatus = response.data.metadata.status;

        // イベント開催日
        this.eventDateAt = response.data.metadata.event_date_at[this.lang];

        // ページ数をセット
        this.$page.current = this.$route.query.page;

        // ページング
        this.offset = (this.$route.query.page - 1) * 100;
      } catch (e) {
        if (e.response.status === 404) {
          this.$page.rows = 0;
          this.isNotFound = true;
          return;
        }
        this.isServerError = true;
      } finally {
        this.isLoadingRanking = false;
      }
    },
  },
  computed: {
    Ranking: function () {
      return Ranking;
    },
    lang: function () {
      return this.$store.state.lang;
    },
    langPath: function () {
      return this.$store.state.langPath;
    },
  },
  components: {
    Wrapper,
    Loading,
    BadRequest,
    InternalServerError,
    Status,
    UserSearch,
    RankingList,
  },
  watch: {
    "$page.current": function (newNumber) {
      this.$router.push(
        {
          name: this.name,
          query: {
            event: this.$route.query.event,
            page: newNumber,
          },
        },
        this.fetchRanking
      );
    },
  },
  name: "Runner",
};
</script>

<style scoped>
.main {
  .button {
    margin: 20px 0 0 auto;
    width: 100px;
    height: 45px;
    font-size: 16px;
    color: var(--defaultBlackColor);
    border: solid 1px var(--defaultBlackColor);
    background-color: var(--defaultWhiteColor);
  }
  .page-title {
    margin: 20px 0 0 0;
    font-size: 24px;
    font-weight: normal;
    word-break: break-word;
    .strong {
      font-weight: 900;
    }
  }
  .section {
    margin: 40px 0 0 0;
    .hit {
      color: #70757a;
    }
    .certificate-download {
      margin: 10px 0 0 0;
      padding: 10px;
      font-size: 12px;
      background-color: var(--defaultGrayColor);
    }
    .update-area {
      margin: 12px 0 0 0;

      .button {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 140px;
        height: 45px;
        border: solid 1px var(--defaultBlackColor);
        background-color: var(--defaultWhiteColor);
      }
    }
  }
  .search-section {
    margin: 40px -15px 0 -15px;
    padding: 40px 0;
    border-top: solid 1px var(--defaultBlackColor);
  }
  .rank-pagination {
    margin: 60px 0 0 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/sp/ranking/runner/Runner.vue